import type { LinkMap } from "@saflib/links";

const subdomain = "";

export const rootLinks: LinkMap = {
  home: {
    subdomain,
    path: "/",
  },
  ai: {
    subdomain,
    path: "/ai",
  },
  about: {
    subdomain,
    path: "/about",
  },
  contact: {
    subdomain,
    path: "/contact",
  },
};
